import React from "react";
import TextArea from "../FormControl/TextArea/TextArea";
import styles from "./index.module.scss";

import { SchemaForm } from "../../Hooks/Seo/schemaFormFormik";

const Schema = (props) => {
  const schemaData = props.data ? props.data : {};

  const schemaInitalValues = {
    schema: schemaData.schema ? schemaData.schema : "",
  };

  const submit = (values) => {};
  const cbSubmit = (values) => {
    props.setSchemaData(values);
  };

  const { formik: schemaFormik } = SchemaForm(
    submit,
    schemaInitalValues,
    cbSubmit,
    props.checkSchemaData
  );

  return (
    <form onSubmit={(e) => schemaFormik.handleSubmit(e)} id={`schema-section`}>
      <div>
        <h3 className={styles.seotitle}>Structured Data (JSON-LD)</h3>
        <TextArea
          label="Schema"
          rows={8}
          value={schemaFormik.values.schema}
          onChange={(data) => {
            schemaFormik.setValues((v) => {
              return {
                ...v,
                schema: data,
              };
            });
          }}
          onBlur={schemaFormik.handleBlur}
          touched={schemaFormik.touched.schema}
          error={schemaFormik.errors.schema}
          id="schema"
          disabled={props.isDisableFields}
        />
        <p className="text-muted small mb-2">
          Optional. Paste raw JSON-LD, for example an FAQPage or HowTo block.
        </p>
        <button className="d-none schema-submit-button" type="submit"></button>
      </div>
    </form>
  );
};

export default Schema;
